import supplierCodeEnum from '@/enums/supplierCodeEnum';
import services from 'services';
import axios from 'axios';
import _ from 'lodash';
import { basicUtils } from '../../../utils/utils';
import store from '../../../store';

export default {
  ediPostBody(cartItems, shopId, noOrder, cmdId, orderType, date, supplier) {
    const products = [];
    cartItems.forEach((item) => {
      products.push({
        STORE_ID: shopId,
        ORDER_ID: noOrder,
        SUPPLIER_ID: this.findSupplierCodeByName(supplier),
        ORDER_DATE: Date.now(),
        PARTNER_PLU_ID: item.ref,
        ORDERED_QTY: item.quantity,
        PACKAGING_UNIT: item.packaging,
        PACKAGING: 'PCE',
        NAME: item.name,
        VAT_RATE: item.tva ? item.tva : 5.5,
        PRICE: parseFloat(item.prix),
        EAN: parseInt(item.ean, 10) ? item.ean : null,
      });
    });
    return {
      INFORMATIONS: {
        STORE_ID: shopId,
        ORDER_ID: noOrder,
        SUPPLIER_ID: this.findSupplierCodeByName(supplier),
        ORDER_DATE: basicUtils.currentDatePostgresStyle(),
        ORDER_HOUR: basicUtils.currentHourPostgresStyle(),
        CMD_ID: cmdId,
        ORDER_TYPE: orderType,
        ORDER_RECEPTION_DATE: date,
      },
      ORDERS: products,
    };
  },

  cartBySupplierToArray(cartBySupplier) {
    return Object.keys(cartBySupplier)
      .map((key) => ({
        key,
        value: cartBySupplier[key],
      }));
  },

  findSupplierCodeByName(supplier) {
    return supplierCodeEnum[supplier];
  },

  totalPriceBySupplier(supplier) {
    if (!store.getters['cart/cartBySupplier'][supplier]) {
      return 0;
    }
    return Math.floor(store.getters['cart/cartBySupplier'][supplier]
      .reduce((a, b) => ({ realPrice: a.realPrice + b.realPrice })).realPrice);
  },

  getFranco(supplier) {
    return store.getters['supplier/suppliersByShopId']
      .find((s) => s.name === supplier)
      .order_constraint
      .franco;
  },

  getFrancoPercentage(supplier) {
    return this.totalPriceBySupplier(supplier) < this.getFranco(supplier)
      ? Math.floor((this.totalPriceBySupplier(supplier) / this.getFranco(supplier)) * 100)
      : 100;
  },

  async checkLastOrder(shopId, supplier) {
    const lastOrder = await services.HistoryService.getLatestHistoryBySupplier(shopId, supplier);
    if (!lastOrder.length) {
      return true;
    }
    return Date.now() - lastOrder[0].time >= 3600 * 1000 * 24;
  },

  async getLastOrderTimeBySupplier(shopId, supplier) {
    const histo = await services.HistoryService.getLatestHistoryBySupplier(shopId, supplier);
    return histo[0].time;
  },

  getSupplierHours(supplier) {
    return store.getters['supplier/suppliersByShopId']
      .find((s) => s.name === supplier)
      .order_constraint
      .hours;
  },

  getSupplierDisplayDate(supplier) {
    const constraint = store.getters['supplier/suppliersByShopId']
      .find((s) => s.name === supplier)
      .order_constraint;

    // eslint-disable-next-line no-prototype-builtins
    if (constraint.hasOwnProperty('shouldDisplayDate')) {
      return constraint.shouldDisplayDate;
    }
    return true;
  },

  async getAgidraShopId(shopId) {
    console.log(shopId);
    let error = false;
    const list = await axios.get(process.env.VUE_APP_AGIDRA_URL)
      .catch((e) => {
        error = true;
        console.log(e);
      });
    if ((error)) {
      return shopId;
    }
    const shopTargeted = _.find(
      list.data.mapping, (obj) => obj.codeBlachere === parseInt(shopId, 10),
    );
    if (!shopTargeted) {
      return shopId;
    }
    return shopTargeted
      .codeAgidra;
  },
};
